/**
 * Using this component for Jobs (New) Status Management
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { isNil } from "lodash";
import StatusNoteNew from "../../../../custom-ui/input-fields/modals/StatusNoteNew";
import toast from "react-hot-toast";
import ToastAlert from "../../../../custom-ui/toast-alert/ToastAlert";
import useModal from "../../../../../hooks/useModal";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../../providers/database";
import MakeJobLive_EmpNewUi from "../../../../custom-ui/input-fields/modals/MakeJobLive";
import RenewJobInAdvanceModal from "../../../../custom-ui/input-fields/modals/RenewJobInAdvanceModal";


const RenewJobInAdvance = ({
  status,
  collection,
  recId,
  jobData,
  required,
  renewFromAdmin= false,
  name,
  daysLeft,
  display,
  placeholder,
  directions,
}) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [statusID, setStatusID] = useState(status);
  const [statusCollection, setStatusCollection] = useState("");
  const [mainCollection, setMainCollection] = useState(collection);

  useEffect(() => {
    if (mainCollection === "JobDetailsNewCollection") {
      setStatusCollection("JobState");
    }
  }, [mainCollection, statusCollection]);

  const { isShowing: isShowingNote, toggle: toggleNote } = useModal();

  const handleDone = (message, newStatus) => {
    toggleNote();
    if (message !== undefined) {
      toast.success(message);
    }
    if (newStatus !== undefined) {
      setStatusID(newStatus);
    }
  };

  useEffect(() => {
    setStatusID(status);
  }, [status]);

  useEffect(() => {
    if (
      !isNil(statusCollection) &&
      statusCollection !== "" &&
      !isNil(statusID) &&
      statusID !== ""
    ) {
      const activeStatusCollection = doc(db, statusCollection, statusID);
      async function fetchOptions(docRef, myStatusCollection) {
        await getDoc(docRef)
          .then(async (data) => {
            setCurrentStatus(data.data().label);
          })
          .catch((error) => {
            console.log(error);
          });
      }
      fetchOptions(activeStatusCollection, statusCollection);
    }
  }, [statusID, statusCollection]);


  return (
    <div id={name} className=" w-full underline cursor-pointer text-instant-teams-blue-Main flex justify-end  mb-4">
      {(currentStatus === "Live") &&
        <RenewJobInAdvanceModal
          onDone={handleDone}
          collection={collection}
          id={recId}
          jobData={jobData}
          disabled={jobData?.isArchived}
          name={name}
        daysLeft={daysLeft}
        renewFromAdmin={renewFromAdmin}
          display={display}
          placeholder={placeholder}
          status={status}
          required={required}
          directions={directions}
          statusCollection={statusCollection}
          minLength={10}
        />}
      <ToastAlert />
    </div>
  );
};

export default RenewJobInAdvance;
